import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

class LayoutService {
    public async getSharepointLink(): Promise<any> {
        return http.get(Routes.linksRoutes.GetSharepointLink());
    }
}
export default new LayoutService();
